var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-icons:lightning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 0L2.625 9V27L18 36L33.375 27V9L18 0Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3374 27L16.9574 20.0145L13.3154 16.419L20.6849 9L19.0619 15.9975L22.6829 19.5735L15.3374 27Z",
    fill: "#2F3444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.c4d531b4668db7b33a251a9d623ddef9.svg";
export { ForwardRef as ReactComponent };